/**
 * Profile URL with its includes. The includes are a function of flags in every ENTITIES
 * entry, so the caller passes `isEnabled` (checkIfFeatureFlagEnabled) and this stays pure.
 * @param {Object} params
 * @param {{ endpoint: string, includes: Function }} params.entity ENTITIES.<entity>
 * @param {number|string} [params.id] Profile id
 * @param {(flag: string) => boolean} params.isEnabled
 * @returns {string} `{entity.endpoint}/{id}?includes=a,b`, or '' without id so the fetch is skipped
 */
export const buildProfileEndpoint = ({ entity, id, isEnabled }) => {
  if (!id) return '';

  const includes = entity.includes(isEnabled).join(',');

  return includes ? `${entity.endpoint}/${id}?includes=${includes}` : `${entity.endpoint}/${id}`;
};
